import {
  IonBadge,
  IonButton,
  IonCol,
  IonIcon,
  IonImg,
  IonItem,
  IonModal,
  IonRow,
  IonText,
} from "@ionic/react";
import { arrowBackOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { makeGETRequest, makePATCHRequest } from "../../request/rawRequest";
import { User } from "../../types/user";
import { displayTechnoActive, technosActive } from "../TechnoList/TechnoList";

import {
  getCurrentTechno,
  getCurrentTechnoOrDisconnect,
  jobsArray,
  jobsMap,
} from "../../variables/jobDictionnary";
import "./Me.css";

interface Prop {
  pathReturn: boolean;
}

const getPremium = (
  actual: string
): {
  value: string;
  display: string;
} => {
  switch (actual) {
    case "pat":
      return { value: "boul", display: "Accès au CAP Boulangerie" };
    case "boul":
      return { value: "pat", display: "Accès au CAP Patisserie" };
  }
  return { value: "not", display: "Aucune autre technologie disponible" };
};

const Me: React.FC<Prop> = ({ pathReturn }) => {
  const history = useHistory();
  const [notifNumber, setNotifNumber] = useState<number>(0);
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const otherTechno = getPremium(getCurrentTechno());
  const [user, setUser] = useState<User>({
    creationDate: "",
    email: "",
    first_name: "",
    last_name: "",
    level: 0,
    phone_number: "",
    picture_url: "",
    role: "",
    validated: false,
    premium: false,
    pole: "",
  });

  const getUserData = async () => {
    if (user.email === "") {
      makeGETRequest("/me").then((res) => {
        setUser(res);
      });
    }
  };

  useEffect(() => {
    if (user.email.length > 0) {
      if (user.pole !== undefined && user.pole !== getCurrentTechno()) {
        localStorage.setItem("techno", user.pole);
        window.location.reload();
      } else if (user.pole === undefined) {
        setModalOpen(true);
      } else if (localStorage.getItem("techno") === undefined) {
        localStorage.clear();
        window.location.reload();
      }
    }

    if (user.validated === true) {
      makeGETRequest("/notifications").then((res) => {
        setNotifNumber(res.length);
      });
    }
  }, [user]);

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <>
      <IonRow style={{ minHeight: "40px" }}></IonRow>

      <IonModal isOpen={modalOpen} canDismiss={false}>
        <IonItem className="ion-text-center">
          <h3 className="ion-text-center">Veuillez choisir une technologie</h3>
        </IonItem>
        <IonCol>{displayTechnoActive(technosActive, "12", true)}</IonCol>
      </IonModal>
      <IonRow className="ion-justify-content-center">
        <IonCol
          //bakcground col
          size-lg="5"
          size-sm="10"
        >
          <IonRow
            className="border-radius container-bg"
            style={{ alignItems: "stretch", marginBottom: 50 }}
          >
            <IonCol
              //col container of :
              // picture img
              // return btn
              size-lg="3"
              size="3"
              size-sm="3"
              style={{ minWidth: "100px", position: "relative" }}
              className="no-margin no-padding"
            >
              <IonRow
                // img row container
                class="ion-justify-content-center"
              >
                <IonCol
                  style={{ maxHeigh: "100px" }}
                  className="no-margin no-padding"
                  class="flex ion-justify-content-center ion-align-items-center"
                >
                  <div
                    className="second-border-avatar"
                    style={{ position: "relative" }}
                  >
                    {notifNumber > 0 && (
                      <IonBadge
                        className="badge"
                        color="danger"
                        style={{
                          fontSize: 20,
                          padding: 5,
                        }}
                      >
                        {notifNumber}
                      </IonBadge>
                    )}
                    <IonBadge className="badge badge-xp" color="secondary">
                      niveau : {user.level}
                    </IonBadge>

                    <IonImg
                      onClick={() => (window.location.href = "/auth/account")}
                      className="app-logo round-avatar "
                      src={user.picture_url}
                      alt="profil pic"
                    />
                  </div>
                </IonCol>
              </IonRow>
              {pathReturn === true && (
                <IonRow
                // return btn container
                >
                  <IonButton
                    shape="round"
                    color="secondary"
                    onClick={() => {
                      if (
                        window.location.pathname.includes("/videogen") === true
                      ) {
                        history.push("/auth/pole/generiques");
                      } else if (
                        window.location.pathname.includes("/generiques") ||
                        window.location.pathname.includes("/competences")
                      ) {
                        history.push("/");
                      } else if (
                        window.location.pathname.includes("/pole/video") ===
                        true
                      ) {
                        history.push("/auth/pole/competences");
                      } else {
                        history.goBack();
                      }
                    }}
                    style={{
                      position: "absolute",
                      bottom: -50,
                      // top: -10,
                      left: "25%",
                    }}
                  >
                    <IonIcon icon={arrowBackOutline} slot="icon-only" />
                  </IonButton>
                </IonRow>
              )}
            </IonCol>
            <IonCol
              onClick={() => (window.location.href = "")}
              style={{ marginLeft: "20px" }}
            >
              <IonRow
                className="ion-align-items-center"
                style={{ height: "100%" }}
              >
                <IonCol className="no-padding no-margin">
                  <IonRow>
                    <IonText color="black">
                      <h5 className="no-margin">{process.env.REACT_APP_NAME?.toUpperCase()}</h5>
                    </IonText>
                  </IonRow>
                  <IonRow>
                    <IonText color="white">
                      <h5 className="no-margin uppercase subtitle-me bold">
                        CAP {jobsMap.get(getCurrentTechno())?.label}
                      </h5>
                    </IonText>
                  </IonRow>
                </IonCol>
              </IonRow>
            </IonCol>
          </IonRow>

          {user.role === "admin" ? (
            <IonRow
              className="ion-justify-content-end"
              style={{
                marginTop: "15px",
              }}
            >
              {jobsArray.map((job, index) => (
                <IonCol
                  key={index}
                  className="ion-justify-content-end flex"
                  size="min"
                >
                  <IonButton
                    style={{
                      "--border-color": "var(--ion-color-secondary)",
                      "--border-style": "solid",
                      "--border-width": "2px",
                      "--color": "var(--ion-color-secondary)",
                    }}
                    shape="round"
                    onClick={async () => {
                      localStorage.setItem("techno", job.href);

                      await makePATCHRequest(
                        "/pole?pole=" + getCurrentTechnoOrDisconnect()
                      )
                        .then(() => {
                          window.location.href = "";
                        })
                        .catch(() => {
                          localStorage.removeItem("authToken");
                        });
                    }}
                  >
                    {job.labelUpper}
                  </IonButton>
                </IonCol>
              ))}
            </IonRow>
          ) : (
            ((user.premium === true && user.role !== "admin") ||
              user.role === "teacher") && (
              <IonRow
                className="ion-justify-content-end"
                style={{
                  marginTop: "15px",
                }}
              >
                <IonCol
                  className="ion-justify-content-end flex"
                  size-lg="5"
                  size-sm="10"
                >
                  <IonButton
                    shape="round"
                    color="secondary"
                    onClick={async () => {
                      localStorage.setItem("techno", otherTechno.value);

                      await makePATCHRequest("/pole?pole=" + otherTechno.value)
                        .then(() => {
                          window.location.href = "";
                        })
                        .catch(() => {
                          localStorage.removeItem("authToken");
                        });
                    }}
                  >
                    {otherTechno.display}
                  </IonButton>
                </IonCol>
              </IonRow>
            )
          )}
        </IonCol>
      </IonRow>
    </>
  );
};

export default Me;
